export default function Tutorial() {
    return (
        <div className="tutorial">
            <span className="tutorial-text">Click on objects in scenario to edit them</span>
        </div>
    );
}
